import React, { useState } from 'react';
import { XCircleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import SchedulingIssuesDrawer from '../steps/validation/SchedulingIssuesDrawer';

const SchedulingSection = ({
    validationData,
    isSessionExcluded,
    handleExcludeSession,
    handleIncludeSession,
    handleExcludeCrewAllSessions,
    handleIncludeCrewAllSessions,
    openAdjustAvailabilityModal,
    isUpdatingCrew,
    formatDate,
    sessionOverrides,
    handleClearSessionOverride,
    getUserInfo,
}) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const crews = validationData?.scheduling_feasibility?.crew_analysis || [];
    const crewsWithIssues = crews.filter((crew) => {
        const hasNonFeasibleSessions = (crew.session_feasibility || []).some(
            (sf) => !sf.feasible && !sf.excluded
        );
        return hasNonFeasibleSessions;
    });

    return (
        <div className="rounded-lg bg-white p-4 shadow sm:p-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div className="flex-1">
                    <div className="mb-2 flex items-center gap-3">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-sm font-medium text-blue-600">
                            2
                        </div>
                        <div>
                            <h3 className="text-base font-medium text-gray-900">Resolve Scheduling Issues</h3>
                            <p className="text-sm text-gray-600">Adjust crew availability or exclude non-feasible sessions</p>
                        </div>
                    </div>

                    {crewsWithIssues.length > 0 ? (
                        <div className="ml-11">
                            <div className="mb-2 flex items-center gap-2">
                                <XCircleIcon className="h-4 w-4 text-red-500" />
                                <span className="text-sm text-red-600">
                                    {crewsWithIssues.length} crew{crewsWithIssues.length === 1 ? '' : 's'} have scheduling issues
                                </span>
                            </div>
                        </div>
                    ) : (
                        <div className="ml-11">
                            <div className="flex items-center gap-2 text-green-600">
                                <CheckCircleIcon className="h-4 w-4 text-green-500" />
                                <span className="text-sm">All crews can be scheduled successfully</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="sm:ml-4">
                    <button
                        onClick={() => setIsDrawerOpen(true)}
                        className={`w-full rounded px-3 py-1.5 text-sm font-medium text-white sm:w-auto ${crewsWithIssues.length > 0 ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-600 hover:bg-gray-700'
                            }`}
                    >
                        {crewsWithIssues.length > 0 ? 'Review & Fix' : 'Edit Scheduling'}
                    </button>
                </div>
            </div>
            <SchedulingIssuesDrawer
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                schedulingFeasibility={validationData?.scheduling_feasibility}
                isSessionExcluded={isSessionExcluded}
                handleExcludeSession={handleExcludeSession}
                handleIncludeSession={handleIncludeSession}
                handleExcludeCrewAllSessions={handleExcludeCrewAllSessions}
                handleIncludeCrewAllSessions={handleIncludeCrewAllSessions}
                openAdjustAvailabilityModal={openAdjustAvailabilityModal}
                isUpdatingCrew={isUpdatingCrew}
                formatDate={formatDate}
                sessionOverrides={sessionOverrides}
                handleClearSessionOverride={handleClearSessionOverride}
                getUserInfo={getUserInfo}
            />
        </div>
    );
};

export default SchedulingSection;


